export default __webpack_public_path__ + "static/media/dashboard.68b051d7.svg";